export {default} from './PanelBossNote.container';
